import React from 'react'
import { Route, Switch } from 'react-router-dom'

import MessageError from './MessageError'
import Modal from './Modal/index'

const ContainerShipping = React.lazy(() => import('./ContainerShipping/index'))
const ResetPassword = React.lazy(() => import('./ResetPassword/index'))
const UserProfile = React.lazy(() => import('./UserProfile/index'))
const EditProfile = React.lazy(() => import('./EditProfile/index'))
const TrackingPage = React.lazy(() => import('./TrackingPage/index'))
const ShareBookingMobile = React.lazy(() => import('./LiveTrackingForNoneBooker/MobileWebView/ShareBookingMobile.tsx'))

const Navigation = () => (
  <>
    <Modal />
    <Switch>
      <Route exact path="/" component={ContainerShipping} />
      <Route exact path="/booking/:id" component={ContainerShipping} />
      <Route exact path="/reset-password" component={ResetPassword} />
      <Route exact path="/profile" component={UserProfile} />
      <Route exact path="/profile-edit" component={EditProfile} />
      <Route exact path="/tracking/:id" component={TrackingPage} />
      <Route exact path="/tracking-for-non-booker/:id" component={ShareBookingMobile} />
    </Switch>
    <MessageError />
  </>
)

export default Navigation
